/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
/**
 * Platform components cannot reach the i18n layer and the gauges take no label
 * props, so the two glyphs they draw are named constants here. A level that was
 * never recorded is rendered with `EMPTY_PLACEHOLDER` from `shared/web`.
 */
export const EMPTY_LABEL = 'E';
export const FULL_LABEL = 'F';
